import { render } from "./ClinicalAssessmentComponent.vue?vue&type=template&id=fcc1e2f2&scoped=true"
import script from "./ClinicalAssessmentComponent.vue?vue&type=script&lang=js"
export * from "./ClinicalAssessmentComponent.vue?vue&type=script&lang=js"

import "./ClinicalAssessmentComponent.vue?vue&type=style&index=0&id=fcc1e2f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcc1e2f2"]])

export default __exports__